export default function pdfData(Logo){
    var docDefinition = {
        pageMargins: [ 15, 10, 20, 20 ],
        pageSize: 'A3',
        content: [
            {
                columns: [
                    {
                        image: Logo,
                    },
                    {
                    width: '50%',
                    text: [
                        { text: 'Sanat Teknoloji\n\n', bold: true },
                        { text: 'Adres: ', bold: true },
                        { text: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9/A Ümraniye / İstanbul \n' },
                        { text: 'Telefon: ', bold: true },
                        { text: '0850 259 00 99\t' },
                        { text: 'E-posta: ', bold: true },
                        { text: 'bilgi@sanatteknoloji.com.tr\n' },
                        { text: 'İnternet Adresi: ', bold: true },
                        { text: 'www.sanatteknoloji.com.tr' },
                    ]
                    },
                ],
                margin: [0, 0, 0, 15],
                linearGradient: ['red', 'green', 'blue', 'red'],
                
            },
            {
                table : {
                    headerRows : 1,
                    widths: ['100%'],
                    body : [ [''], [''] ]
                },
                layout : 'headerLineOnly'
            },              
            {
                table: {
                    headerRows: 1,
                    margin:[0],
                    widths: [90, 90, 130, '*', '*', '*', '*', '*', '*', '90%'],
                    body: [
                        [
                            { text: 'Ad', bold: true, alignment: 'center' },
                            { text: 'Vergi/TC Kimlik No', bold: true, alignment: 'center' },
                            { text: 'Adres', bold: true, alignment: 'center' },
                            { text: 'İl', bold: true, alignment: 'center'},
                            { text: 'İlçe', bold: true, alignment: 'center' },
                            { text: 'Kamera', bold: true, alignment: 'center' },
                            { text: 'Alarm', bold: true, alignment: 'center' },
                            { text: 'Sözleşme No', bold: true, alignment: 'center' },
                            { text: 'Başlangıç Tarihi', bold: true, alignment: 'center' },

                        ],
                    ]
                },
                layout: 'lightHorizontalLines'
            },
        ] 
    };
    return docDefinition
}


// WEBPACK FOOTER //
// ./src/pages/General/Reports/pdf/pdf.js